<div class="mss-modal__header">
    <div class="mmh__title">
        {{ page.title }}
    </div>
    <div class="mmh__close pointer"  (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
    </div>
</div>
<ion-content class="ion-content__modal">
    <ng-container *ngFor="let block of page.content">
        <ng-container [ngSwitch]="block.type">

            <ng-container *ngSwitchCase="Blocks.TEXT">
                <app-block-text [item]="block"></app-block-text>
            </ng-container>

            <ng-container *ngSwitchCase="Blocks.HIGHLIGHTS">
                <app-block-highlight [item]="block"></app-block-highlight>
            </ng-container>

            <ng-container *ngSwitchCase="Blocks.VIDEO">
                <app-block-video [item]="block"></app-block-video>
            </ng-container>

            <ng-container *ngSwitchCase="Blocks.CHAT">
                <app-block-chat></app-block-chat>
            </ng-container>

        </ng-container>
    </ng-container>

    <div class="fade-text"></div>
</ion-content>
